import React, { useEffect, useState } from "react";
import { FaShieldAlt, FaSmile, FaClock, FaUserTie } from "react-icons/fa";
import "./OurValues.css";
import { BASE_URL } from "../../../Components/Base_url/Base_Url";

const Values = () => {
    const [values, setValues] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${BASE_URL}/feature/`)
            .then((res) => res.json())
            .then((data) => {
                setValues(data.data || []); // API response me jo array mile
            })
            .catch((err) => console.error("Error fetching values:", err))
            .finally(() => setLoading(false));
    }, []);

    return (
        <section className="section-padding">
            <div className="container">
                <div className="section-title">
                    <h2>Our Values</h2>
                    <p>The principles that guide our actions</p>
                </div>

                {loading ? (
  <p>Loading...</p>
) : (
  <div className="values-container">
    {values.map((item, index) => (
      <div className="value-item" key={item.id || index}>
        <div className="value-icon">
          <img
            src={
              item.feature_icon
                ? `${BASE_URL}${item.feature_icon}` // 👈 Correct: item.feature_icon
                : "/img/default-icon.png"           // fallback if null
            }
            alt={item.main_content}
          />
        </div>
        <h3>{item.main_content}</h3>
        <p>{item.feature_name}</p>
      </div>
    ))}
  </div>
)}

            </div>
        </section>
    );
};

export default Values;
